export const createTextNode = (zwibbler, config) => {
  zwibbler.beginTransaction();
  var node = zwibbler.createNode("TextNode", {
    text: "Hello world",
    fontSize: 50,
    fontName: "Arial",
    matrix: [1, 0, 0, 1, 100, 100]
  });
  zwibbler.translateNode(node, 100, 100);
  zwibbler.commitTransaction();
};
export const createImgNode = (zwibbler, options) => {
  const node = zwibbler.createNode("ImageNode", {
    url: options.url,
    matrix: [1, 0, 0, 1, options.x, options.y]
  });
  return null;
};

export const copySelectedNode = zwibbler => {
  let snippet = zwibbler.copy(true);
  snippet = snippet.substring(13);

  return snippet;
};

export const copy = zwibbler => {
  zwibbler.copy();
};

export const paste = zwibbler => {
  zwibbler.paste();
};

export const pasteSnippet = (zwibbler, snippit) => {
  const clip = "zwibblerclip." + JSON.stringify(snippit);
  zwibbler.paste(clip)
};

export const deleteSelection = zwibbler => {
  return zwibbler.deleteSelection();
};

export const deleteNode = (zwibbler, nodes) => {
  return zwibbler.deleteNodes(nodes);
};

export const arrangeSelection = (zwibbler, arrangeCommand) => {
  const selectedNodes = zwibbler.getSelectedNodes();
  if (!selectedNodes) return null;
  if (arrangeCommand === "up") {
    return zwibbler.moveUp(selectedNodes);
  }
  if (arrangeCommand === "down") {
    return zwibbler.moveDown(selectedNodes);
  }
  if (arrangeCommand === "front") {
    return zwibbler.bringToFront(selectedNodes);
  }
  if (arrangeCommand === "back") {
    return zwibbler.sendToBack(selectedNodes);
  }
};

export const groupSelection = zwibbler => {
  const selectedNodes = zwibbler.getSelectedNodes();
  return zwibbler.createGroup(selectedNodes);
};

export const unGroup = zwibbler => {
  const selectedNodes = zwibbler.getSelectedNodes();
  return zwibbler.ungroup(selectedNodes);
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/ExternalApi/handlers/Nodes.js